import React from "react";
import { Container, Row } from "react-bootstrap";

const HolderContainer = (props) => {
  return (
    <div className="container-holder-main-body">
      <div className="container-holder-body">{props.children}</div>
    </div>
  );
};

export default HolderContainer;
